module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-568-retro.31fe5b95.jpg";